import React from "react";
import axios from "axios";
import { store } from '../../redux/store';
import { connect } from "react-redux";
import history from "../../auth/history";
import BillListSubComponent from "./BillListSubComponent";
import moment from "moment";
import Pagination from "react-js-pagination";
import { selectedConsumerList, setBillListEndIndex, setBillListStartIndex, setSelectedAmount } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class BillListHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            consumerList: [],
            message: '',
            activePage: 1,
            startIndex: 0,
            endIndex: 5
        }
    }



    componentDidMount() {
        store.dispatch(selectedConsumerList([]));
        store.dispatch(setSelectedAmount(0));
        if (this.props.billListConsumers.slice(0, 5).length > 0) {
            store.dispatch(setBillListStartIndex(0))
            store.dispatch(setBillListEndIndex(5))
            setTimeout(() => {
                this.setState({
                    consumerList: this.props.billListConsumers.slice(0, 5)
                })
            }, 300);

        }


    }

    handlePageChangeDefault(pageNumber) {


        this.setState({
            activePage: pageNumber,
            consumerList: []
        })

        console.log(pageNumber);
        var startIndex = (pageNumber - 1) * 5;
        var endIndex = pageNumber * 5;

        this.setState({
            startIndex: startIndex,
            endIndex: endIndex,
        })
        store.dispatch(setBillListStartIndex(startIndex))
        store.dispatch(setBillListEndIndex(endIndex))

        setTimeout(() => {
            this.setState({
                consumerList: this.props.billListConsumers.slice(startIndex, endIndex)
            })
        }, 300);

    }

    componentWillUnmount() {
    }




    render() {

        return (
            <div>

                <div class="duehstry">


                    {this.props.billListConsumers.length > 0 &&
                        this.props.billListConsumers.slice(this.props.billListStartIndex,
                            this.props.billListEndIndex)
                            .map(consumer => (
                                <BillListSubComponent
                                    consumer={consumer}
                                    options={this.props.options}
                                />
                            ))}


                </div>

                <div class="pager">
                    <p>Showing {this.props.billListStartIndex + 1} to {this.props.billListEndIndex >=
                        this.props.billListConsumers.length ?
                        this.props.billListConsumers.length : this.props.billListEndIndex + " "}
                        of {this.props.billListConsumers.length} entries</p>
                    <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={(this.props.billListEndIndex - this.props.billListStartIndex) > 5 ?
                             this.props.billListEndIndex :
                            5}
                        totalItemsCount={
                            this.props.billListConsumers.length}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChangeDefault.bind(this)}
                        className="pagination"
                        linkClass="page-link"
                        itemClass="page-item"
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, token, agentInfo, billListConsumers,
            clientRole, billListStartIndex, billListEndIndex } }
) => ({
    errorMessage, loginErrorMessage, phone, token, agentInfo, billListConsumers, clientRole,
    billListStartIndex, billListEndIndex
});

export default connect(mapStateToProps, null)(BillListHistory);
